export default "__VITE_ASSET__1f522c6f__"